export default "__VITE_ASSET__KHXuulwm__"